var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",on:{"click":function($event){return _vm.$emit('select', _vm.entry)}}},[_c('div',[_vm._v(_vm._s(_vm.entry.shortName))]),_c('div',[_vm._v(_vm._s(_vm.entry.fullName))]),_c('div',[_vm._v(_vm._s(_vm.entry.year))]),_c('div',[_vm._v(_vm._s(_vm.entry.expert))]),_c('div',[_vm._v(_vm._s(_vm.entry.contractor.shortName || '-'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }